"use strict";

var _tokenRetrievalAdapter = _interopRequireDefault(require("../adapters/tokenRetrievalAdapter"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var cachedTokens = {};
var getBatchTokenData = function getBatchTokenData(urlTemplate, apiKey, batchUrlTemplate) {
  var tokenRetrieval = new _tokenRetrievalAdapter["default"]({
    urlTemplate: urlTemplate,
    apiKey: apiKey,
    batchUrlTemplate: batchUrlTemplate
  });
  return tokenRetrieval.getBatchTokensByApiKey();
};
var processBatchData = function processBatchData(tokenData) {
  tokenData.keys().forEach(function (cid) {
    cachedTokens[cid] = tokenData[cid];
  });
};
var getCachedToken = function getCachedToken(clientId) {
  return cachedTokens[clientId];
};
var getCachedTokenString = function getCachedTokenString(clientId) {
  var cachedToken = getCachedToken(clientId);
  return "".concat(cachedToken.TokenType, " ").concat(cachedToken.IdToken);
};
var tokenInvalid = function tokenInvalid(token) {
  return !token || token.ValidTo && new Date(token.ValidTo).getTime() < Date.now();
};
var requestTokens = function requestTokens(clientId, urlTemplate, apiKey, batchUrlTemplate) {
  return getBatchTokenData(urlTemplate, apiKey, batchUrlTemplate).then(processBatchData).then(function () {
    return getCachedTokenString(clientId);
  });
};
module.exports = {
  initialize: function initialize(authSettings) {
    processBatchData(authSettings.tokens);
  },
  // Returns a promise
  getToken: function getToken(_ref) {
    var clientId = _ref.clientId,
      urlTemplate = _ref.urlTemplate,
      apiKey = _ref.apiKey,
      batchUrlTemplate = _ref.batchUrlTemplate;
    var token = getCachedToken(clientId);
    if (tokenInvalid(token)) {
      return requestTokens(clientId, urlTemplate, apiKey, batchUrlTemplate);
    } else {
      return Promise.resolve("".concat(token.TokenType, " ").concat(token.IdToken));
    }
  }
};